export default "/wp-content/themes/onnit/script/cart/dist/thBg-34cfb930.jpg";